import React from 'react';

/**
 * POS Reports sidebar icon — active state. Same geometry as the inactive
 * variant but stroked in the brand teal (#0F7679) to match how other
 * icons signal selection.
 */
const POSReportsActiveIcon: React.FC = () => {
  return (
    <svg
      width="34"
      height="38"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <rect
        x="2.5"
        y="16"
        width="3.5"
        height="5"
        rx="1"
        stroke="#0F7679"
        strokeWidth="1.6"
      />
      <rect
        x="8"
        y="11"
        width="3.5"
        height="10"
        rx="1"
        stroke="#0F7679"
        strokeWidth="1.6"
      />
      <rect
        x="13.5"
        y="13"
        width="3.5"
        height="8"
        rx="1"
        stroke="#0F7679"
        strokeWidth="1.6"
      />
      <rect
        x="19"
        y="6"
        width="3.5"
        height="15"
        rx="1"
        stroke="#0F7679"
        strokeWidth="1.6"
      />
      <path
        d="M3 8 L9.5 4 L15 6.5 L21 2.5"
        stroke="#0F7679"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
};

export default POSReportsActiveIcon;
